export const getReportResponses = ({ reportResponses }) => reportResponses;
export const getServerConfig = ({ serverConfig }) => serverConfig;
export const getFallbackReport = ({ reports }) => {
  const result = reports.find(({ clickFallback }) => clickFallback);
  return result;
};
